var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('PressNotesPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormPressNotesPg',{attrs:{"loading":_vm.loading,"getPressNotesPg":_vm.getPressNotesPg},on:{"beforeUpdate":_vm.updatePressNotesPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }